import { render, staticRenderFns } from "./SamSecondaryButton.vue?vue&type=template&id=815f2076&scoped=true&"
import script from "./SamSecondaryButton.vue?vue&type=script&lang=js&"
export * from "./SamSecondaryButton.vue?vue&type=script&lang=js&"
import style0 from "./SamSecondaryButton.vue?vue&type=style&index=0&id=815f2076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815f2076",
  null
  
)

export default component.exports